export const fixKeys = (kpi) => {
    if ( kpi?.key !== kpi?.originalKey ) return kpi?.key;
    else return kpi?.originalKey;
}